module.exports = __webpack_public_path__ + "img/linux-adv-01-preview.9f833ca4.jpg";